import { render, staticRenderFns } from "./CadaItemVenda.vue?vue&type=template&id=5b9ba84a&scoped=true&"
import script from "./CadaItemVenda.vue?vue&type=script&lang=js&"
export * from "./CadaItemVenda.vue?vue&type=script&lang=js&"
import style0 from "./CadaItemVenda.vue?vue&type=style&index=0&id=5b9ba84a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ba84a",
  null
  
)

export default component.exports